import { inject, injectable } from 'inversify';
import { CustomerChatbotDependencyTypes } from '@client/feature/customer-chatbots/customer-chatbot.dependency-types';
import type { CustomerChatbotRepositoryInterface } from '@client/feature/customer-chatbots/domain/repository/customer-chatbot.repository';
import type { HubspotConversationsWidgetService } from '@client/feature/customer-chatbots/domain/service/hubspot-conversations-widget.service';

@injectable()
export class CustomerChatbotService {
  public constructor(
    @inject(CustomerChatbotDependencyTypes.CustomerChatbotRepository)
    private readonly customerChatbotRepository: CustomerChatbotRepositoryInterface,
    @inject(CustomerChatbotDependencyTypes.HubspotConversationsWidgetService)
    private readonly hubspotConversationsWidgetService: HubspotConversationsWidgetService,
  ) {}

  public async initialize(options: { identifyChatbotVisitorWithAuthenticatedUser: boolean }) {
    if (
      this.hubspotConversationsWidgetService.isVisitorIdentified() !==
      options.identifyChatbotVisitorWithAuthenticatedUser
    ) {
      this.reset();
    }

    if (this.hubspotConversationsWidgetService.isLoaded()) {
      return;
    }

    if (options.identifyChatbotVisitorWithAuthenticatedUser) {
      const { email, token } = await this.customerChatbotRepository.login();
      this.hubspotConversationsWidgetService.identifyVisitor(email, token);
    }

    this.hubspotConversationsWidgetService.load();
  }

  public reset(): void {
    this.hubspotConversationsWidgetService.unIdentifyVisitor();
    this.hubspotConversationsWidgetService.clear();
    this.hubspotConversationsWidgetService.remove();
  }

  public async refresh() {
    this.hubspotConversationsWidgetService.refresh();
  }
}
